module.exports = __webpack_public_path__ + "html/main-landing_a49b678577cbc33a7f42aa9b5e9ab57b.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/main-landing.html
// module id = rVl+
// module chunks = 45